import { map, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SettingsService } from '../services/settings.service';
import { ServerResponse } from '../response';
import { RaceProgress, PollResults, Score, Equal_Score } from '../models';
import { RaceProgressRaw } from '../models/interfaces/race_pogress_raw.interface';

@Injectable({
  providedIn: 'root',
})
export class ProtocolDomainService {
  constructor(
    private settingService: SettingsService,
    private http: HttpClient
  ) { }

  // Получает данные для формирования протокола в личном зачете
  getPersonalResult(rUid: string, clUid: string): Observable<any[]> {
    return this.http
      .get<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/protocol/personal`, {
        params: {
          rUid,
          clUid,
        },
      })
      .pipe(
        map((res: any) => {
          res.data.forEach((per: any) => {
            per.name = per.name.split('$').join('\r\n');
          });
          return res.data;
        })
      );
  }

  // Получает данные для формирования сводного протокола по нескольким заездам/гонкам
  getOverallResult(races: string[], className: string, score: Score, scores_equal: Equal_Score): Observable<any> {
    return this.http.post<ServerResponse<any>>(`${this.settingService.settings.urlGTM}/api/protocol/overall`, {
      races,
      className,
      score: score,
      scores_equal: scores_equal,
    }).pipe(
      map((res: any) => res.data)
    );
  }

  // Получает данные для протокола командного зачета
  getTeamResults(rUid: string, clUid: string): Observable<any[]> {
    return this.http
      .get<any[]>(
        `${this.settingService.settings.urlGTM}/api/protocol/teams?rUid=${rUid}&clUid=${clUid}`
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Получает данные для протокола опроса при регистрации
  getPollResults(rUid: string): Observable<PollResults> {
    return this.http
      .get<PollResults>(
        `${this.settingService.settings.urlGTM}/api/protocol/poll_results?rUid=${rUid}`
      )
      .pipe(
        map((res: any) => res.data)
      );
  }

  // Получает новые данные прогресса
  getNewProgress(rUid: string, clUid?: string): Observable<RaceProgress> {
    const params: any = {
      rUid,
      lang: this.settingService.selectedLang,
    };

    if (clUid) {
      params['clUid'] = clUid;
    }

    return this.http
      .get<ServerResponse<RaceProgressRaw>>(`${this.settingService.settings.urlGTM}/api/protocol/new_progress`, { params })
      .pipe(
        map((res: any) => new RaceProgress(res.data))
      );
  }
}
